import { connect } from 'react-redux';

import * as Profile from 'app/entities/Profile';

import SidebarRight from './SidebarRight';

const mapStateToProps = (state, props) => {
  const currentProfile = Profile.selectors.all.currentProfile(state);

  return {
    children: props.children,
    // TODO: remove this when we no longer need it.
    isStaff: Profile.selectors.isStaff(currentProfile),
  };
};

export default connect(mapStateToProps)(SidebarRight);
